/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type ServicedeskQueuesConfigType from '@jira/spa-apps__servicedesk-queues-config/src/index.tsx';
import type { SettingsContainerContentQuery } from '@jira/servicedesk__queues-config/src/__generated__/SettingsContainerContentQuery.graphql.ts';
import type { EntryPointProps } from 'react-relay';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { Match, Route, RouteContext } from '@atlassian/react-resource-router';

/**
 * @deprecated remove when jsm_views_inside_queues_-_main_flag is cleaned up
 */
export const LazyServicedeskQueuesViewsConfig: LazyComponent<
	({
		queries: { SettingsContainerContentQuery },
		extraProps,
	}: EntryPointProps<
		{
			SettingsContainerContentQuery: SettingsContainerContentQuery;
		},
		{},
		{},
		{
			query: {
				config?: string;
			};
			match: Match;
			route: Route;
		}
	>) => React.JSX.Element
> = lazyForPaint<typeof ServicedeskQueuesConfigType>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-queues-views-config", jiraSpaEntry: "async-servicedesk-queues-config" */ '@jira/spa-apps__servicedesk-queues-config/src/index.tsx'
		),
);

/**
 * @deprecated remove when jsm_views_inside_queues_-_main_flag is cleaned up
 */
export const ServicedeskQueuesViewsConfig = (props: RouteContext): React.JSX.Element => {
	const { query } = props;
	return (
		<LazyPage
			Page={LazyServicedeskQueuesViewsConfig}
			pageId={`spa-apps/servicedesk/queues/views-config/${query.config}`}
			shouldShowSpinner
		/>
	);
};
